import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[allowOnlyNumbers]'
})
export class AllowOnlyNumbersDirective {

  constructor(private ref: ElementRef) { }

  @HostListener('input', ['$event'])
  input(e: InputEvent) {
    const value = (e.target as any).value;
    const filteredValue = value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');
    this.ref.nativeElement.value = filteredValue;
  }

}
